module.exports = __webpack_public_path__ + "static/media/grass.1344a143.jpeg";